import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';
import { cx, INPUT, LABEL } from './classes.js';

export function Field({
  id,
  label,
  hint,
  children,
}: {
  id: string;
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className={LABEL}>
        {label}
      </label>
      {children}
      {hint ? <div className="text-[13px] text-mute">{hint}</div> : null}
    </div>
  );
}

export function TextInput({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...rest} className={cx(INPUT, className)} />;
}

export function Select({
  className,
  children,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select {...rest} className={cx(INPUT, 'appearance-none', className)}>
      {children}
    </select>
  );
}

/** The artboards' 18px accent-colour checkbox row. */
export function CheckboxRow({
  id,
  checked,
  onChange,
  label,
  note,
  first = false,
  disabled = false,
}: {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  note?: ReactNode;
  first?: boolean;
  disabled?: boolean;
}) {
  return (
    <label
      htmlFor={id}
      className={cx(
        'flex cursor-pointer items-center gap-3 py-3 text-[15px]',
        !first && 'border-t border-line',
        disabled && 'cursor-default text-mute',
      )}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="size-[18px] accent-accent"
      />
      <span>{label}</span>
      {note ? <span className="text-[13px] text-mute">{note}</span> : null}
    </label>
  );
}
